import useUIState from './persistUiState';
import { DocsUIState } from './types';

export const useDocsUIState = (docId: string): DocsUIState =>
  useUIState((state) => ({
    docsFullWidth: state.docsFullWidth,
    setDocsFullWidth: (expanded: boolean) => state.setDocsFullWidth(expanded),
    docScrollHeight: state.docScrollHeight[docId] || 0,
    setDocScrollHeight: (height: number) =>
      state.setDocScrollHeight(docId, height),
    docsExpanded: state.docsExpanded[docId] || false,
    setDocsExpanded: (expanded: boolean) =>
      state.setDocExpanded(docId, expanded),
  }));
